const state = {
  dealerShops: [],
  shopProducts: [
    {children: []}
  ],
  newshopProducts: [
    {children: []}
  ],
  productLink: [],
  activityDecalareTemplateList: [],
  activityDecalareTemplateDetail: []
}
const	getters = {
  getDealerShops: state => {
    return state.dealerShops;
  },
  getShopProducts: state => {
    let res = [];
    for(let i of state.shopProducts) {
      if(i.children) {
        i.productName = i.productClassifyName;
        res.push(i)
      }
    }
    return res;
  },
  newgetShopProducts: state => {
    let res = [];
    for(let i of state.newshopProducts) {
      if(i.children) {
        i.productName = i.productClassifyName;
        res.push(i)
      }
    }
    return res;
  },
  getProductLink: state => {
    return state.productLink;
  },
}
const	mutations = {
  getdealershops(state, payload) {
    state.dealerShops = payload;
  },
  getshopproducts(state, payload) {
    state.shopProducts = payload;
  },
  newgetshopproducts(state, payload) {
    state.newshopProducts = payload;
  },
  getproductlink(state, payload) {
    state.productLink = payload;
  },
  setActivityDecalareTemplateList(state, payload) {
    state.activityDecalareTemplateList = payload;
  },
  setActivityDecalareTemplateDetail(state, payload) {
    state.activityDecalareTemplateDetail = payload;
  },
}
const	actions = {
  reqActivityDecalareTemplateList( { commit }, params ) {
    return new Promise((r, j) => {
      fetch({
        url: "hcm/campgign/getcampaignTemplatemainlist",
        method: "get",
        params: params,
      }).then((res) => {
        console.log(res);
        commit('setActivityDecalareTemplateList', res.data.content);
        r(res.data.content);
      }).catch(() => {
        j();
      })
    })
  },

  reqActivityDecalareTemplateDetail( { commit }, params ) {
    return new Promise((r, j) => {
      fetch({
        url: "hcm/campgign/getCampaignTemplatedetils",
        method: "get",
        params: params,
      }).then((res) => {
        console.log(res);
        commit('setActivityDecalareTemplateDetail', res.data);
        r(res.data);
      }).catch(() => {
        j();
      })
    })
  },
  reqActivityDealerShops( { commit }, params ) {
    return new Promise((r, j) => {
      fetch({
        url: "hcm/hcmShop/findShopsByDealer",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then((res) => {
        let result = JSON.parse(res);
        commit('getdealershops', result.data);
        r(result.data);
      }).catch(() => {
        j();
      })
    })
  },

  reqActivityShopProduct( { commit }, params ) {
    return new Promise((r, j) => {
      fetch({
        url: "hcm/hcmProduct/getListBybmcid",
        method: "get",
        params: params,
      }).then((res) => {
        commit('getshopproducts', res.data);
        r(res.data);
      }).catch(() => {
        j();
      })
    })
  },
  //新
  newreqActivityShopProduct( { commit }, params ) {
    return new Promise((r, j) => {
      fetch({
        url: "hcm/hcmProduct/getProductList",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then((res) => {
        let result = JSON.parse(res);
        commit('newgetshopproducts', result.data);
        r();
      }).catch(() => {
        j();
      })
    })
  },
  reqShopProductLink( { commit }, params ) {
    return new Promise((r, j) => {
      fetch({
        url: "hcm/iprNewPluginList/getPluginlink",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then((res) => {
        let result = JSON.parse(res);
        commit('getproductlink', result.data);
        r(result.data);
      }).catch(() => {
        j();
      })
    })
  },

  reqIsLowPrice( { commit }, params ) {
    return new Promise((r, j) => {
      fetch({
        url: "hcm/campgign/returnState",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then((res) => {
        let result = JSON.parse(res);
        r(result.data);
      }).catch(() => {
        j();
      })
    })
  },

  reqApplyActivity( { commit }, params ) {
    return new Promise((r, j) => {
      fetch({
        url: "hcm/campgign/Apply",
        method: "post",
        data: JSON.stringify(params),
        headers: {
          'Content-Type': 'application/json',
        },
        noFormat: true,
        responseType: "text"
      }).then((res) => {
        let result = JSON.parse(res);
        r(result);
      }).catch(() => {
        j();
      })
    })
  },

}

export default {
  state,
  getters,
  mutations,
  actions
}
